<template>
  <div class="mega-menu__overlay"></div>
</template>

<script>
  export default {
    name: 'MegaMenuOverlay',
  }
</script>

<style lang="scss" scoped>
  div {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,.6);
    z-index: 1000;
    top: 0px;
    left: 0px;
  }
</style>
